import {Injectable} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {RESOURCE_UPDATE, ResourceActions} from '@catfeatures/actions/resource.actions';
import {getServiceForResource} from '@catfeatures/shared/resources';
import {Store} from '@ngrx/store';
import {Restangular} from 'ngx-restangular';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Observable} from 'rxjs/Observable';
import {isNullOrUndefined} from 'util';

@Injectable()
export class GenericResourceApiService {

  private routeBasedParentResource = new BehaviorSubject(null);
  private routeBasedParentResource$ = this.routeBasedParentResource.asObservable();

  constructor(private http: Restangular,
              private route: ActivatedRoute,
              private store: Store<any>,
              private actions: ResourceActions) {
  }

  resolveForId(resourceId: string): Observable<any> {
    return this.getServiceForResource(resourceId).get();
  }

  getServiceForResource(resourceId: string) {
    return getServiceForResource(resourceId, this.http);
  }

  getFromParentResource() {
    this.route.queryParamMap.subscribe((queryParams) => {
      const contextResourceId = queryParams.get('parentResourceId');

      if (isNullOrUndefined(contextResourceId)) {
        console.warn('could not find a valid context', queryParams);
      } else {
        this
          .getServiceForResource(contextResourceId)
          .get()
          .subscribe((featureEvidFunction) => this.routeBasedParentResource.next(featureEvidFunction));
      }
    });
    return this.routeBasedParentResource$;

  }

  save(resourceRef: string, data: any): Observable<any> {
    const service = getServiceForResource(resourceRef, this.http);
    return service.customPUT(data);
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/features/services/generic-resource-api.service.ts